"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageDisplayInMask = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var decideIfFullWidthOrFullHeightImg_1 = require("../../comps/ImageEditor/utils/decideIfFullWidthOrFullHeightImg");
var styled_1 = require("./styled");
var ImageDisplayInMask = function (_a) {
    /**
     * now this is a complex one:
     * our image renderer renders the image at a certain aspect ratio
     * our thumbnail has a fixed aspect ratio of itself that is '1/1'
     * This means that, if the imageeditor is more vertical, it needs to take full width within the thumbnail
     * and full height if it is more horizontal.
     * Basically what happens inside the imageEditor, needs to repeat itself over here..
     *
     */
    var maskAspectRatio = _a.maskAspectRatio, aspectRatio = _a.aspectRatio, //this is the aspectRatio prop that is passed to ImageInput
    imageInputProps = __rest(_a, ["maskAspectRatio", "aspectRatio"]);
    var rendererStretch = (0, decideIfFullWidthOrFullHeightImg_1.decideIfFullWidthOrFullHeightImg)({
        imgWidth: parseInt(aspectRatio.split("/")[0]),
        imgHeight: parseInt(aspectRatio.split("/")[1]),
        wrapperAspectRatio: maskAspectRatio,
    });
    return (react_1.default.createElement(styled_1.StyledAbsPosShellImageEditor, { rendererStretch: rendererStretch },
        react_1.default.createElement(__1.ImageInput, __assign({}, imageInputProps, { aspectRatio: aspectRatio, stretchToFullHeight: rendererStretch === "fullHeight" && true, readOnly: true, enableCaptions: false }))));
};
exports.ImageDisplayInMask = ImageDisplayInMask;
